import React from 'react';

import {Avatar} from '@gravity-ui/uikit';
import block from 'bem-cn-lite';

import type {SubjectClaims} from '../../../../shared/schema/extensions/types';

import './AclSubject.scss';

const b = block('cc-acl-subject');

type Props = {
    subjectClaims: SubjectClaims;
};

export const AclSubject: React.FC<Props> = ({subjectClaims}) => {
    const {name, email, picture, pictureData} = subjectClaims;

    return (
        <div className={b()}>
            <div className={b('avatar')}>
                <div className={b('yc-user-avatar', {size: 'm'})}>
                    <Avatar size="m" imgUrl={picture || pictureData || ''} alt={name} />
                </div>
            </div>
            <div className={b('info')}>
                <div className={b('info-name')} title={name}>
                    {name}
                </div>
                <div className={b('info-meta')} title={email}>
                    {email}
                </div>
            </div>
        </div>
    );
};
